import { MdLocationOn } from 'react-icons/md';
import UserAppContext from '../../hook/UserAppContext';
import Relation from '../relation/Relation';

import './header.css';

const Header = () => {

      const {user, dataApp} = UserAppContext()
      const {infordata} = user.user 

      return (
            <div className="jd_theme__header">
                  <div className="container header">
                        <div className="jd__header_user">
                              <div className="jd_user__avatar tooltip" data-tooltip={infordata.name === '' || infordata.data ? dataApp.info.name : infordata.name} >
                                    <div className="jd_user__avatar_box">
                                          <img src={infordata.avatar === '' || infordata.data ? dataApp.info.avatar : infordata.avatar} alt={infordata.name === '' ? dataApp.info.name : infordata.name} />
                                    </div>
                              </div>
                              <div className="jd_user__data">
                                    <h2>{infordata.name === '' || infordata.data ? dataApp.info.name : infordata.name}</h2>
                                    <p>{infordata.status === '' || infordata.data ? dataApp.info.status : infordata.status}</p>
                                    <strong>{infordata.id_xat === '' || infordata.data ? dataApp.info.id_xat : infordata.id_xat}</strong>
                                    <div className="jd_data__location">
                                          <MdLocationOn />
                                          <span>{infordata.location === '' || infordata.data ? dataApp.info.location : infordata.location}</span>
                                    </div>
                                    <div className="jd_data__find">
                                          <a href={infordata.me === '' || infordata.data ? dataApp.info.me : infordata.me} target="_blank" rel="noreferrer">Find Me</a>
                                    </div>
                              </div>
                        </div>
                        <Relation/>
                  </div>
            </div>
      )
}

export default Header;